import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPage, Page } from './base/page';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class DataStoreService {

    constructor(
        private http: HttpClient,
    ) {}

    /**
     * Get page data from local json file
     * @param stepName - Page name to get the data for.
     */
    getPageData(stepName: string): Observable<IPage> {
        const url = `assets/local_data/${stepName}.json`;
        return this.http
            .get<any>(url)
            .pipe(
                map((ret: any) => new Page(ret.data))
                // finalize(() => this.loader.hideLoading())
            );
    }

}
